"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readbackByType = void 0;
const Cores = __importStar(require("../core"));
const readback_1 = require("../readback");
/**

   # readbackByType

   The eta-expansion can be implemented here.

   But due to the use of `readback` during elaboration,
   performing eta-expansion is not a desired role of `readback`.

**/
function readbackByType(mod, ctx, type, value) {
    switch (type["@kind"]) {
        case "Type": {
            return (0, readback_1.readbackType)(mod, ctx, value);
        }
        case "Trivial": {
            /**
               The η-rule for `Trivial` states that,
               all of its inhabitants are the same as `sole`.
               This is implemented by reading all the
               values of type `Trivial` back to `sole`,
               even the value is `TypedNeutral`.
            **/
            return Cores.Var("sole");
        }
        // case "Pi": {
        //   /**
        //      Everything with a `Pi` type is immediately
        //      `readback` as having a `Fn` on top.
        //      This implements the eta-rule for `Fn`.
        //   **/
        //   const name = type.retTypeClosure.name
        //   const usedNames = [...ctxNames(ctx), ...solutionNames(mod.solution)]
        //   const freshName = freshen(usedNames, name)
        //   const v = Values.TypedNeutral(type.argType, Neutrals.Var(freshName))
        //   const retType = closureApply(type.retTypeClosure, v)
        //   ctx = CtxCons(freshName, type.argType, ctx)
        //   const ret = Actions.doAp(value, v)
        //   return Cores.Fn(freshName, readback(mod, ctx, retType, ret))
        // }
        // case "PiImplicit": {
        //   const name = type.retTypeClosure.name
        //   const usedNames = [...ctxNames(ctx), ...solutionNames(mod.solution)]
        //   const freshName = freshen(usedNames, name)
        //   const v = Values.TypedNeutral(type.argType, Neutrals.Var(freshName))
        //   const retType = closureApply(type.retTypeClosure, v)
        //   ctx = CtxCons(freshName, type.argType, ctx)
        //   const ret = Actions.doApImplicit(value, v)
        //   return Cores.FnImplicit(freshName, readback(mod, ctx, retType, ret))
        // }
        // case "Sigma": {
        //   /**
        //      `Sigma`s are also η-expanded.
        //      Every value with a `Sigma` type,
        //      whether it is neutral or not,
        //      will be `readback` with a `cons` at the top.
        //   **/
        //   const car = Actions.doCar(value)
        //   const cdr = Actions.doCdr(value)
        //   const cdrType = closureApply(type.cdrTypeClosure, car)
        //   return Cores.Cons(
        //     readback(mod, ctx, type.carType, car),
        //     readback(mod, ctx, cdrType, cdr),
        //   )
        // }
        // case "ClazzNull":
        // case "ClazzCons":
        // case "ClazzFulfilled": {
        //   return Cores.Objekt(readbackProperties(mod, ctx, type, value))
        // }
        default: {
            return undefined;
        }
    }
}
exports.readbackByType = readbackByType;
//# sourceMappingURL=readbackByType.js.map